import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import { AddRequestTechnicalSupportDrawerModal } from "@src/components/organisms/modals/add-request-technical-support-drawer-modal/add-request-technical-support-drawer-modal";

export const AddRequestTechnicalSupportDrawer = () => {
  const showModal = useSelector(
    (state: RootState) =>
      state.yourSlice.modals.addRequestTechnicalSupportDrawerModal.showModal,
  );
  return <>{showModal && <AddRequestTechnicalSupportDrawerModal />}</>;
};
